import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import clsx from 'clsx'
import { PageLink, PageTitle, useLayout } from "../../../_metronic/layout/core";
import RelatorioModal from './RelatorioModal';
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { IDetalhesRecomendacao, IMemoriaCalculo } from "../../interfaces/IRelatorio";
import RelatoriosService from '../../services/RelatoriosService';
import { useParams } from 'react-router-dom';
import { Formatter, pegarEmpresaSelecionada, Periodo, Tipo } from "./Relatorio";

interface Column {
  id: string;
  label: string;
  width?: string;
  align?: 'left' | 'center' | 'right';
}

function RelatorioRecomendacao() {

  const { classes } = useLayout();
  const { id } = useParams<{ id: string }>();
  const [page, setPage] = React.useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(10);
  const [dataInicial, setDataInicial] = useState<Date>();
  const [dataFinal, setDataFinal] = useState<Date>();
  const [detalhesRecomendacoes, setDetalhesRecomendacoes] = useState<IDetalhesRecomendacao[]>([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [carregado, setCarregado] = useState<boolean>(false);
  const [memoriasCalculo, setMemoriasCalculo] = useState<IMemoriaCalculo[]>([]);
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Clientes',
      path: '/relatorioSelecionarCliente',
      isSeparator: false,
      isActive: false
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false
    },
    {
      title: 'Relatório',
      path: `/relatorio/${id}`,
      isSeparator: false,
      isActive: false
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: true
    }
  ]
  const columns: Column[] = [
    { id: 'dataString', label: 'Data', width: '10%', align: 'center' },
    { id: 'historico', label: 'Histórico', width: '20%', align: 'center' },
    { id: 'valor', label: 'Valor', width: '10%', align: 'center' },
    { id: 'dc', label: 'D/C', width: '10%', align: 'center' },
    { id: 'simbolo', label: 'Símbolo', width: '10%', align: 'center' },
    { id: 'recomendacao', label: 'Recomendação', width: '40%', align: 'center' }
  ];
  const useStyles = makeStyles({
    root: {
      width: '100%'
    },
    container: {
      maxHeight: 600
    },
    simbolo: {
      '& *': {
        color:'#00B757',
        fontSize: '2rem'
      }
    }
  });
  const styles = useStyles();
  
  useEffect(() => {
    function preCarregar() {
      try
      {
        const titulo = document.querySelectorAll("h1")[0];
        const estilo = titulo.getAttribute('style') + 'font-size: 14px';
        const pageTitle = document.querySelectorAll(".page-title")[0];
        const estiloPageTitle = (pageTitle.getAttribute('style') ?? "") + 'margin-right: 0 !important';

        titulo.setAttribute('style', estilo);
        pageTitle.setAttribute('style', estiloPageTitle);
      } catch {
        setTimeout(() => {
          preCarregar();
        }, 50);
      }
    }
    
    const jsonDataInicial = localStorage.getItem(`${Tipo.DataInicial}`) as "";
    const dataInicial = JSON.parse(jsonDataInicial)  as Date | undefined;
    const jsonDataFinal = localStorage.getItem(`${Tipo.DataFinal}`) as "";
    const dataFinal = JSON.parse(jsonDataFinal)  as Date | undefined;

    setDataInicial(dataInicial);
    setDataFinal(dataFinal);

    preCarregar();
  }, [])
  
  useEffect(() => {
    localStorage.setItem(`${Tipo.DataInicial}`, JSON.stringify(dataInicial));
  }, [dataInicial])

  useEffect(() => {
    localStorage.setItem(`${Tipo.DataFinal}`, JSON.stringify(dataFinal));
  }, [dataFinal])

  useEffect(() => {
    async function preCarregar() {
      setCarregado(false);
  
      const empresa = pegarEmpresaSelecionada();
      const jsonContaEmpresa = localStorage.getItem(`${Tipo.ContaEmpresa}`) as "";
      const contaEmpresa = JSON.parse(jsonContaEmpresa)  as number | undefined;
      
      if (empresa && empresa.id !== 0 && dataInicial && dataFinal) {
        await RelatoriosService.detalhesRecomendacoes(empresa.id, jsonContaEmpresa, dataInicial, dataFinal, x => setDetalhesRecomendacoes(x.filter(p => !contaEmpresa || p.contaEmpresa === contaEmpresa.toString())));
      }
  
      setCarregado(true);
    }

    setTimeout(() => {
      preCarregar();
    }, 1000);
  }, [id, dataInicial, dataFinal])
  
  function handleChangePage(event: unknown, newPage: number) {
    setPage(newPage);
  };

  function handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>) {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function toggleModal(): void {
    setShowModal(!showModal);
  }

  async function carregarModal(controleTributoId: number) {
    await RelatoriosService.memoriaCalculo(controleTributoId, x => setMemoriasCalculo(x));
    toggleModal();
  }

  function acaoBotaoPeriodo(dataInicial: Date | undefined, dataFinal: Date | undefined) {
    setDataInicial(dataInicial);
    setDataFinal(dataFinal);
  }
  
  return <>
    <PageTitle pageBack={`/relatorio/${id}`} breadcrumbs={breadCrumbs}>{ localStorage.getItem(`${Tipo.Recomendacao}`) }</PageTitle>
    <label style={{color: '#525252', fontWeight: 700, fontSize: '20px', marginBottom: '10px'}}>{ dataInicial && dataFinal ? carregado ? detalhesRecomendacoes.length > 0 ? `Recomendações encontradas (${detalhesRecomendacoes.length})` : 'Não foi encontrado nenhuma Recomendação para ser exibida' : 'Carregando...' : 'Preencha o campo Período e clique em buscar para carregar os dados' }</label>
    <div className='toolbar' id='kt_toolbar' style={{ padding: '0 10px' }}>
      <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex')} style={{ padding: '0' }}>
        <DefaultTitle />
        <RelatorioModal memoriasCalculo={memoriasCalculo} show={showModal} toggleModal={toggleModal} />
        <Periodo dadosExportar={null} dataInicio={dataInicial} dataFim={dataFinal} acaoBotaoBuscar={acaoBotaoPeriodo} empresaId={parseInt(id)} />
      </div>
    </div>

      {
        dataInicial && dataFinal && carregado && detalhesRecomendacoes.length > 0 &&
        <>
          <Paper className={styles.root} style={{ outline: '1px solid #A3A3A3' }}>
          <TableContainer className={styles.container}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow style={{ outline: '1px solid #A3A3A3' }} >
                  {
                    columns.map((column, index) =>
                      <TableCell key={index} align={column.align} style={{ width: column.width, color: '#5E6397', fontWeight: 700, backgroundColor: 'white' }}>
                        { column.label }
                      </TableCell>)
                  }
                  <TableCell style={{ backgroundColor: 'white' }} />
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  detalhesRecomendacoes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) =>
                    <TableRow hover role="checkbox" tabIndex={-1} key={index} style={{ outline: '1px solid #A3A3A3'}}>
                      {
                        columns.map((column, index) =>
                          <TableCell key={index} align={column.align} style={{ width: column.width }}>
                            {
                              column.id === 'simbolo' ?
                                <div className={styles.simbolo} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(row.simbolo) }} />
                              :
                                column.id === 'valor' ? 
                                  Formatter.format(row['valor'])
                                : 
                                  row[column.id as keyof IDetalhesRecomendacao]
                            }
                          </TableCell>)
                      }
                      <TableCell>
                        <button onClick={async () => await carregarModal(row.controleTributoID)} className='btn btn-sm btn-primario' style={{backgroundColor: '#005E96', height: '28px', width: '35px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <i className="bi bi-arrows-move" style={{color: '#ffffff'}} />
                        </button>
                      </TableCell>
                    </TableRow>)
                }
              </TableBody>
            </Table>
          </TableContainer>
          </Paper>
          <TablePagination rowsPerPageOptions={[]} component="div" count={detalhesRecomendacoes.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
        </>
      }
  </>
};

export default RelatorioRecomendacao;

